// Thin wrapper around the GA4 gtag.js tag loaded in public/index.html.
// Every call is guarded: analytics must never break a form submission, and the
// tag may be absent (ad blockers, local dev, consent tooling).

function hasGtag() {
    return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

/**
 * Fire a GA4 event. Silently no-ops when the tag isn't available.
 */
export function trackEvent(name, params = {}) {
    if (!hasGtag()) return;
    try {
        window.gtag('event', name, params);
    } catch (e) {
        /* analytics must never throw into the UI */
    }
}

/**
 * A lead was captured. `generate_lead` is GA4's recommended event name — mark it
 * as a Key Event in GA4 and it can be imported into Google Ads as a conversion,
 * which is what lets the ad platform optimise and gives you cost-per-lead.
 *
 * @param {object} lead  { service, budget, formType }
 */
export function trackLead({ service, budget, formType } = {}) {
    trackEvent('generate_lead', {
        // GA4 expects currency when a value is present; we send none since lead
        // value varies. Add value/currency here if you later price a lead.
        form_type: formType || 'contact',
        service: service || undefined,
        budget: budget || undefined,
    });
}
